import * as React from "react";
const SvgTickSquare = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 17"
    {...props}>
    <path
      {...props}
      stroke={props.stroke || "#464A4D"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4.242 8.5 2.5 2.5 5.009-5"
    />
  </svg>
);
export default SvgTickSquare;
